import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "el-transition"

export default class extends Controller {
    static targets = [ "content", "background" ]

    static values = {
        isBackend: { type: Boolean, default: false },
        inlineRequest: { type: Boolean, default: false }
    }

    connect() {
        document.addEventListener('turbo:submit-end', this.handleSubmit.bind(this))
        //document.addEventListener('keydown', this.handleEscape.bind(this))
        this.formDataQueryString = this.getQueryString()
        enter(this.backgroundTarget)
    }

    disconnect() {
        document.removeEventListener('turbo:submit-end', this.handleSubmit)
        document.dispatchEvent(new CustomEvent('modal:closed'))
        //document.removeEventListener('keydown', this.handleCloseModal)
    }

    getQueryString() {
        const form = this.element.querySelector('form')
        if (form === null) {
            return ''
        }
        const formData = new FormData(form)
        return new URLSearchParams(formData).toString()
    }

    close(e, force = false) {
        if ((e === undefined || (e?.target?.tagName === 'INPUT' && e?.constructor === Event) || e?.target?.tagName === 'FORM') && !force) {
            return;
        }
        const controller = this
        const newQueryString = this.getQueryString()
        let confirmed = true

        if (newQueryString !== this.formDataQueryString && this.isBackendValue) {
            e.preventDefault()
            confirmed = confirm('Änderungen gehen verloren!')
        }
        if (confirmed) {
            leave(controller.backgroundTarget).then(() => {
                controller.element.remove();
                controller.disconnect()
            })
        }
        //this.element.dispatchEvent(new CustomEvent('modal:close', { detail: { event: e }}))
    }

    handleEscape(e) {
        if (e.defaultPrevented) {
          return;
        }
        if(e.key === "Escape") {
            this.close(e)
            e.preventDefault()
        }
    }

    handleSubmit(e) {
        const redirected = e?.detail?.fetchResponse?.response?.redirected
        const rspStatus = e?.detail?.fetchResponse?.response?.status

        const modalInlineRequest = (e?.target?.dataset?.modalInlineRequestValue || false)

        if (e.detail.success && rspStatus !== 204 && !modalInlineRequest) {
            if (!redirected) {
                this.isBackendValue = false
                this.close(e, true)
            }
        }
    }
}
